<template>
  <body class="fixed-header horizontal-menu horizontal-app-menu">
    <div class="header p-r-0 bg-primary m-b-10">
      <div class="header-inner header-md-height">
        <a
          href="#"
          class="btn-link toggle-sidebar d-lg-none text-white sm-p-l-0 btn-icon-link"
          data-toggle="horizontal-menu"
        >
          <i class="bi bi-list"></i>
        </a>
        <div class="">
          <div class="brand inline no-border d-sm-inline-block">
            <h4 class="text-white">ADMIN ONLINE MEDIA MONITORING</h4>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <i
            v-if="theme == 'dark-mode'"
            class="bi bi-sun clickable hoverable"
            style="font-size: 20px; color: white !important"
            @click="changeTheme('light-mode')"
          ></i>
          <i
            v-else
            class="bi bi-moon-stars clickable hoverable"
            style="font-size: 20px; color: white !important"
            @click="changeTheme('dark-mode')"
          ></i>
          <div
            class="ml-3 pull-left p-r-10 fs-14 font-heading d-lg-inline-block d-none text-white"
          >
            Hallo, <span class="semi-bold">{{ fullname }}</span>
          </div>
          <span class="text-white">|</span>
          <a
            href="#"
            @click="logout"
            class="header-icon m-l-10 sm-no-margin sm-p-r-0 d-inline-block"
          >
            <i class="bi bi-box-arrow-right text-white"></i>
          </a>
        </div>
      </div>
      <div
        class="bg-white"
      >
        <div class="container-fluid p-r-45">
          <div
            class="menu-bar header-sm-height"
            data-pages-init="horizontal-menu"
            data-hide-extra-li="4"
          >
            <a
              href="#"
              class="btn-link header-icon toggle-sidebar d-lg-none"
              data-toggle="horizontal-menu"
            >
              <i class="bi bi-x"></i>
            </a>
            <ul class="admin-menu-wrapper">
              <li id="dashboard-link" class="admin-menu" @click="activeLink">
                <router-link to="/admin/dashboard"> Dashboard </router-link>
              </li>
              <li id="cronjob-link" class="admin-menu" @click="activeLink">
                <router-link to="/admin/cronjob"> Cronjob </router-link>
              </li>
              <li id="setting" class="admin-menu" @click="activeLink">
                <router-link to="/admin/setting"> Setting </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="page-container">
      <div class="page-content-wrapper">
        <div class="content">
          <div class="container-fluid container-fixed-lg">
            <router-view />
          </div>
        </div>
        <div class="container-fluid container-fixed-lg footer">
          <div class="copyright sm-text-center">
            <p class="small-text no-margin pull-left sm-pull-reset">
              Online Media Monitoring © 2020 All Rights Reserved. PT Kabayan
              Aishwarya Nusantara
            </p>
            <p class="small no-margin pull-right sm-pull-reset">
              Online Media Monitoring
              <span class="hint-text"> v{{ version }}</span>
            </p>
            <div class="clearfix" />
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import $ from "jquery";
import Cookie from "js-cookie";
import VueJwtDecode from "vue-jwt-decode";
import cookie from "js-cookie";

export default {
  name: "MainLayout",
  data() {
    return {
      theme: this.$store.getters.theme
        ? this.$store.getters.theme
        : "light-mode",
      fullname: this.$store.getters.user.fullname,
      renew_call: false,
      version: process.env.PACKAGE_VERSION,
    };
  },
  methods: {
    changeTheme: function (theme) {
      this.theme = theme;
      const app = document.getElementsByTagName("body")[0];
      console.log(app);
      if (app) {
        if (this.theme == "light-mode") {
          app.classList.remove("dark-mode");
          app.classList.add("light-mode");
        } else {
          app.classList.remove("light-mode");
          app.classList.add("dark-mode");
        }
      }
      this.$store.dispatch("set_theme", this.theme);
      cookie.set("medmon_theme", this.theme);
    },
    activeLink: function () {
      if (event.target.nodeName == "A") {
        var el = $(event.target).closest(".admin-menu");
        el.parent().children().removeClass("active");
        el.addClass("active");
      }
    },
    logout: function () {
      event.preventDefault();
      this.$store.dispatch("logout").then(() => {
        let ref = encodeURI(btoa("logout"));
        let teks = encodeURI(btoa("Anda berhasil keluar dari sistem."));
        let title = encodeURI(btoa("Berhasil!"));
        this.$router.push({
          path: "/login",
          query: { log: teks, ref: ref, log_t: title },
        });
      });
    },
  },
  created: function () {
    const app = document.getElementsByTagName("body")[0];
    if (app) {
      if (this.theme == "light-mode") {
        app.classList.remove("dark-mode");
        app.classList.add("light-mode");
      } else {
        app.classList.remove("light-mode");
        app.classList.add("dark-mode");
      }
    }
    this.$http.interceptors.request.use((config) => {
      let api = process.env.VUE_APP_API_URL;
      let white_lists = [
        api + "login",
        api + "renew-access",
        api + "renew-refresh",
      ];

      if (!white_lists.includes(config.url)) {
        let refresh_token = Cookie.get("medmon_refresh");
        if (!refresh_token && !this.renew_call) {
          this.renew_call = true;
          this.$store.dispatch("logout").then(() => {
            let ref = encodeURI(btoa("logout"));
            let teks = encodeURI(
              btoa("Sesi Anda telah berakhir, silakan masuk kembali.")
            );
            let title = encodeURI(btoa("Maaf!"));
            this.$router.push({
              path: "/login",
              query: { log: teks, ref: ref, log_t: title },
            });
          });
        }

        let token = Cookie.get("medmon_ref");
        if (token) {
          config.headers["token"] = token;
        } else {
          config.headers["token"] = "xx";
        }
      }
      return config;
    });
    this.$http.interceptors.response.use(undefined, (error) => {
      let api = process.env.VUE_APP_API_URL + "renew-access";
      let refresh_token = Cookie.get("medmon_refresh");
      const originalRequest = error.config;
      if (error.response.status === 401 && originalRequest.url === api) {
        return Promise.reject(error);
      }
      if (error.response.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
        if (typeof refresh_token !== "undefined") {
          let userID = this.$store.getters.user.user_id.$oid;
          let data = {
            "refresh-token": refresh_token,
            uid: userID,
          };
          return this.$http.post(api, data).then((res) => {
            if (res.status === 200) {
              let token = res.data["access-token"];
              this.$http.defaults.headers.common["token"] = token;

              let token_decode = VueJwtDecode.decode(token);
              let token_exp = token_decode.exp * 1000;
              let token_expire = new Date(token_exp);
              Cookie.set("medmon_ref", token, { expires: token_expire });

              return this.$http(originalRequest);
            }
          });
        }
      }

      return Promise.reject(error);
    });
  },
  mounted: function () {
    var path = this.$route.path;
    if (path == "/admin/visitor") {
      $("#visitor-link").addClass("active");
    } else {
      $("#dashboard-link").addClass("active");
    }
  },
};
</script>

<style scoped>
@import "../../../../public/pages/css/themes/modern.css";
.horizontal-app-menu .menu-bar > ul > li > a {
  padding: 0px 5px;
  color: #28a745 !important;
}
</style>